module.exports = __webpack_public_path__ + "static/img/banner5.13c8455.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner5.png
// module id = /Oaz
// module chunks = 0